import { bool, func, string } from 'prop-types';
import React from 'react';
import DataCutSettings from './subcomponents/DataCutSettings';
import MatchExceptions from './subcomponents/MatchExceptions';
import ActionableHeaderCard from 'ps-components/Card/ActionableHeaderCard';

const propTypes = {
  reviewDataCuts: func,
  showDataCut: bool,
  dataCutOption: string,
  typeOfReview: string,
  autoReviewOption: string,
  toggleDataCutOption: func,
  setDataCutOption: func,
  setAutoReviewOption: func,
  setTypeOfReview: func,
  dataCutOptionsSaved: bool,
  noExceptions: bool
};

const MigrationSettingsContent = props => {
  const {
    toggleDataCutOption,
    setDataCutOption,
    showDataCut,
    reviewDataCuts,
    dataCutOption,
    typeOfReview,
    autoReviewOption,
    setAutoReviewOption,
    setTypeOfReview,
    dataCutOptionsSaved,
    noExceptions
  } = props;

  const renderMatchExceptions = dataCutOptionsSaved && !noExceptions;
  return (
    <React.Fragment>
      <ActionableHeaderCard
        cardTitle="When the Migration Started"
        className="survey-migration-settings__panel info"
        cardTitleClassName="survey-migration-settings__heading"
      >
        <p>
          <i className="icon-check" />
          Easy Matches will be auto-migrated
        </p>
        <p>
          <i className="icon-check" />
          Any unknown adhoc pricing will be automatically deleted
        </p>
      </ActionableHeaderCard>
      <DataCutSettings
        setDataCutOption={setDataCutOption}
        dataCutOptionsSaved={dataCutOptionsSaved}
        noExceptions={noExceptions}
        toggleDataCutOption={toggleDataCutOption}
        reviewDataCuts={reviewDataCuts}
        showDataCut={showDataCut}
        dataCutOption={dataCutOption}
      />
      {(!dataCutOptionsSaved || renderMatchExceptions) && (
        <MatchExceptions
          typeOfReview={typeOfReview}
          dataCutOptionsSaved={dataCutOptionsSaved}
          noExceptions={noExceptions}
          autoReviewOption={autoReviewOption}
          setAutoReviewOption={setAutoReviewOption}
          setTypeOfReview={setTypeOfReview}
          isPriorityMatch={showDataCut}
        />
      )}
    </React.Fragment>
  );
};

MigrationSettingsContent.propTypes = propTypes;
export default MigrationSettingsContent;
